import React, { FC } from "react";
import { useSelector } from "react-redux";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
// import ConfirmVerificationCodeForm from "./components/ConfirmVerificationCodeForm";
import SignUpForm from "./components/SignUpForm";
import { ReduxApplicationState } from "../../types/ReduxTypes/ReduxApplicationState";

// import { useLocation } from "react-router-dom";

const users = new Set(["irina", "alexmoore", "galendow2", "galendow123", "poolshark", "lux.thwala"]);

const SignUpPage: FC = () => {
  // const location = useLocation();
  // const { userName } = Object.fromEntries(new URLSearchParams(location.search));
  const user = useSelector((state: ReduxApplicationState) => state.user.currentUser);

  return (
    <AuthFlowLayout
      heading="Join BrandGen.io"
      description="Create account: to view your personalized dashboard, campaigns, and audiences."
    >
      {users.has(user) && <SignUpForm />}
      {/* {userName ? <ConfirmVerificationCodeForm userName={userName} /> : <SignUpForm />} */}
    </AuthFlowLayout>
  );
};

export default SignUpPage;
